/**
 * Returns true if a value is considered "not set":
 * - null / undefined
 * - empty string (after trimming)
 * - empty array (length === 0)
 * - empty plain object (no own enumerable keys)
 *
 * Explicit primitives such as `false`, `0` and `NaN` are NOT empty.
 */
export const isEmpty = (value: unknown): boolean => {
  if (value == null) {
    return true;
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  if (typeof value === 'string') {
    return value.trim().length === 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
};
